import { PacketStatus } from '@promo/shared';

/** Mapping of PacketStatus enum keys to human-friendly labels */
export const packetStatusLabels: Record<PacketStatus, string> = {
  [PacketStatus.DRAFT]: 'Draft',
  [PacketStatus.BLINDED_ASSESSMENT]: 'Assessments',
  [PacketStatus.UNBLINDED_ASSESSMENT]: 'Assessments',
  [PacketStatus.MANAGER_SUMMARY]: 'Review',
  [PacketStatus.SENIOR_LEADER_REVIEW]: 'Review',
  [PacketStatus.HR_REVIEW]: 'Review',
  [PacketStatus.COMPLETED]: 'Decision',
  [PacketStatus.WITHDRAWN]: 'Withdrawn',
};

/**
 * Returns the human-friendly label for a given status.
 * Falls back to capitalizing the raw string if unknown.
 */
export function getPacketStatusLabel(status: PacketStatus | string): string {
  const label = packetStatusLabels[status as PacketStatus];
  if (label) return label;
  return getDistinctPacketStatusLabel(status as PacketStatus);
} 

export function getDistinctPacketStatusLabel(status: PacketStatus): string {
  const s = String(status).replace(/_/g, ' ');
  // Capitalize each word except acronyms
  return s.split(' ').map(word => {
    if (word === 'HR') return word;
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
}